import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 20, label: 'Full Primary School' },
    { value: 21, label: 'Contributing Primary School' },
    { value: 22, label: 'Intermediate School' },
    { value: 23, label: 'Specialist School' },
    { value: 30, label: 'Secondary School' },
    { value: 32, label: 'Composite School' },
    { value: 34, label: 'The Correspondence School' },
    { value: 35, label: 'Restricted Composite School' },
    { value: 40, label: 'Secondary School' },
    { value: 41, label: 'Teen Parent Unit' },
  ],
});
